// extracted by mini-css-extract-plugin
module.exports = {"container":"oddDetails__container___u7lNc","team":"oddDetails__team___2I5wB","market":"oddDetails__market___1QDW4"};